module.exports = __webpack_public_path__ + "media/תות.9acce4a1.mp3";